/** Route paths exposed by the mating feature. */
export const matingRoutePaths = {
    mating: '/mating-h',
    bullSelectorH: '/bullselector-h',
    bullSelectorC: '/bullselector-c',
};
